
const paginationStyle = {
    paging :{
        display: "flex",
        justifyContent: "flex-end"
    }
}

export default paginationStyle